import Input from 'Shared/Input/v2';
import React, { useContext } from 'react';
import { DateCopima } from 'Shared/RangeDate';
import AutoCompleteCmp from 'Shared/Select/AutoCompleteCmp';
import { useSelector } from 'react-redux';
import { makeSelectExpeditions, makeSelectPaymentModes, makeSelectSalers } from 'selectors';
import ReferencialContext from 'Shared/ReferencialContext';
import { SOUCHES, ALL_DEVISE } from 'Components/ControleOrders/constants';
import { DEPOSITS, INCOTERMS } from '../constants';
import { INTERNATION_TRANSPORT, formatTranportName } from './constants';

const Fields = [{ name: 'date', type: 'date' },
  {
    name: 'incoterme',
    label: 'INCOTERME',
    type: 'select',
    options: INCOTERMS,
    getOptionLabel: (option) => (option),
    filterOptions: (ops, v) => ops
      .filter((o) => !v.inputValue || o.toLowerCase().includes(v.inputValue.toLowerCase())),
  },
  { name: 'datePort', label: 'DATE ARRIVÉE PORT', type: 'date' },
  {
    name: 'repo', label: 'DÉPÔT', type: 'select', options: DEPOSITS,
  },
  {
    name: 'transporteur',
    label: 'TRANSPORTEUR',
    type: 'select',
    options: INTERNATION_TRANSPORT,
    getOptionLabel: formatTranportName,
    filterOptions: (ops, v) => ops
      .filter((o) => !v.inputValue || o.toLowerCase().includes(v.inputValue.toLowerCase())),
  },
  { name: 'dateCopima', label: 'DATE ARRIVÉE COPINA', type: 'date' },
  {
    name: 'devise',
    label: 'DEVISE',
    type: 'select',
    options: ALL_DEVISE,
    getOptionLabel: (o) => o.name,
    filterOptions: (ops, v) => ops
      .filter((o) => !v.inputValue || o.name.toLowerCase().includes(v.inputValue.toLowerCase())),
  },
  { name: 'cours', label: 'COURS DEVISE' }, { name: 'poid' },
  { name: 'nbrePalettes', label: 'NOMBRE PALETTES' },
  {
    name: 'importPaymentMode',
    label: 'MODALITÉ DE PAIEMENT',
    type: 'select',
    getOptionLabel: (option) => (option.paymentMode),
    filterOptions: (ops, v) => ops
      .filter((o) => !v.inputValue || o.toLowerCase().includes(v.inputValue.toLowerCase())),
  }];

const EditHeader = ({
  document, onChange, importPaymentModes, enumLibreCials, fileds = null,
}) => {
  const {
    state: {
      referencial: { clients },
    },
  } = useContext(ReferencialContext);
  const salers = useSelector(makeSelectSalers());
  const expeditions = useSelector(makeSelectExpeditions());
  const paymentModes = useSelector(makeSelectPaymentModes());
  const FieldsUpdated = (fileds || Fields).map((field) => {
    if (field.name === 'expedition') {
      return { ...field, options: expeditions };
    }

    if (field.name === 'importPaymentMode') {
      return { ...field, options: importPaymentModes };
    }

    if (field.name === 'paymentMode') {
      return { ...field, options: paymentModes };
    }

    if (field.name === 'client') {
      return { ...field, options: clients };
    }

    if (field.name === 'biller') {
      return { ...field, options: enumLibreCials.billers };
    }
    if (field.name === 'picker') {
      return { ...field, options: enumLibreCials.pickers };
    }
    if (field.name === 'packedBy') {
      return { ...field, options: enumLibreCials.packeds };
    }
    if (field.name === 'saler') {
      return { ...field, options: salers };
    }
    return field;
  });
  const onChangeDate = (name) => (date) => onChange({ target: { name, value: date } });

  const onChangeSelect = (name) => (event, value) => {
    if (name === 'client' && value) {
      if (value.expedition) {
        const defaultExp = expeditions.find((exp) => exp.name === value.expedition);
        if (defaultExp) {
          onChange({ target: { name: 'expedition', value: defaultExp } });
        }
      }
      if (value.payment) {
        const defaultP = paymentModes.find((exp) => exp.name === value.payment);
        if (defaultP) {
          onChange({ target: { name: 'paymentMode', value: defaultP } });
        }
      }
      if (value.type) {
        if (value.type === 'FA') {
          onChange({ target: { name: 'souche', value: SOUCHES[0] } });
        } else if (value.type === 'MF') {
          onChange({ target: { name: 'souche', value: SOUCHES[1] } });
        }
      }
    }
    onChange(value ? { target: { name, value } } : event);
  };
  return (
    <>
      {FieldsUpdated.map((field) => {
        if (field.type === 'date') {
          return (
            <DateCopima
              label={field.label || field.name.toUpperCase()}
              value={document[field.name] ? new Date(document[field.name]) : null}
              name={field.name}
              onChange={onChangeDate(field.name)}
              sx={{
                width: '190px', border: '1px solid #007BC6', mt: '8px', mb: '4px',
              }}
            />
          );
        }

        if (field.type === 'select') {
          return (
            <AutoCompleteCmp
              options={field.options}
              onChange={onChangeSelect(field.name)}
              value={document[field.name]}
              label={field.label}
              name={field.name}
              disabled={field.disabled}
              getOptionLabel={field.getOptionLabel}
              filterOptions={field.filterOptions}
              isPrimaryTheme
              style={{
                marginTop: 8, marginBottom: 4, maxWidth: 190, display: 'inline-block', border: '1px solid #007BC6',
              }}
            />
          );
        }
        return (
          <Input
            value={document[field.name]}
            onChange={onChange}
            style={{
              marginTop: 8, marginBottom: 4, width: '190px', border: '1px solid #007BC6',
            }}
            label={field.label || field.name.toUpperCase()}
            disabled={field.disabled}
            name={field.name}
            type={field.type || 'text'}
          />
        );
      })}
    </>
  );
};

export default EditHeader;
